import React, { useEffect, useState } from "react";

import {
  Box,
  Divider,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Chip,
  Stack,
  Button,
} from "@mui/material";
import { NavLink } from "react-router-dom";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import DoneIcon from "@mui/icons-material/Done";
import ScheduleIcon from "@mui/icons-material/Schedule";
import LogoutIcon from "@mui/icons-material/Logout";
import EventIcon from "@mui/icons-material/Event";
import BeachAccessIcon from "@mui/icons-material/BeachAccess";
import { allowedUsers } from "./constants";
import {AccountingUid} from "./constants";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import axios from "axios";

const normalizeBaseUrl = (raw) => {
  if (!raw) return "";
  const trimmed = raw.trim().replace(/\/$/, "");
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

export default function DrawerContent({ onLogout, onClose }) {
  const handleNavClick = () => onClose();

  const username = localStorage.getItem("saved_sett_mobilenumber") || "";
  // console.log("DEBUG username:", JSON.stringify(username));
  // console.log("DEBUG allowedUsers:", allowedUsers);
  // console.log("DEBUG includes result:", allowedUsers.includes(username));
    const showAttendanceDropdown = allowedUsers.includes(username);
  
      // "Approve Visit Request" is only for accounting, or anyone currently
  // assigned as a SupervisorId in Visit Roles. These are TWO DIFFERENT
  // identifiers, not interchangeable:
  //   - AccountingUid holds UID-style values, matched against
  //     saved_username — exactly the same field VisitApprovalPage's own
  //     isHr check uses.
  //   - visit_supervisor.SupervisorId is an EmpId (VisitSupervisorPage
  //     assigns it from /api/employees' `empid`), matched against
  //     shared_empid instead.
  const savedUsername = localStorage.getItem("saved_username") || "";
  const empId = localStorage.getItem("shared_empid") || "";

  const isAccountingForVisits = AccountingUid.includes(savedUsername);
  const [canApproveVisits, setCanApproveVisits] = useState(isAccountingForVisits);

  const isHrForLeaves = allowedUsers.includes(savedUsername);
  const [canApproveLeaves, setCanApproveLeaves] = useState(isHrForLeaves);

  useEffect(() => {
    if (isAccountingForVisits) {
      setCanApproveVisits(true);
      return;
    }
    if (!empId) {
      setCanApproveVisits(false);
      return;
    }
    const rawBase = localStorage.getItem("saved_sett_api_url");
    const API_BASE_URL = normalizeBaseUrl(rawBase);
    if (!API_BASE_URL) {
      setCanApproveVisits(false);
      return;
    }

    axios
      .get(`${API_BASE_URL}/api/visit/roles`)
      .then((res) => {
        const roles = Array.isArray(res.data) ? res.data : [];
        const isVisitSupervisor = roles.some((r) =>
          (r.supervisors || []).some((s) => String(s.supervisorId) === String(empId)),
        );
        setCanApproveVisits(isVisitSupervisor);
      })
      .catch(() => setCanApproveVisits(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empId, isAccountingForVisits]);

  

  useEffect(() => {
    if (isHrForLeaves) {
      setCanApproveLeaves(true);
      return;
    }
    if (!empId) {
      setCanApproveLeaves(false);
      return;
    }
    const rawBase = localStorage.getItem("saved_sett_api_url");
    const API_BASE_URL = normalizeBaseUrl(rawBase);
    if (!API_BASE_URL) {
      setCanApproveLeaves(false);
      return;
    }

    axios
      .get(`${API_BASE_URL}/api/leave-roles`)
      .then((res) => {
        const roles = Array.isArray(res.data) ? res.data : [];
        const isLeaveSupervisor = roles.some((r) =>
          (r.supervisorIds || []).some((id) => String(id) === String(empId)),
        );
        setCanApproveLeaves(isLeaveSupervisor);
      })
      .catch(() => setCanApproveLeaves(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empId, isHrForLeaves]);


  return (
    <Box
      sx={{
        // width: 246,
        // height: "100%",
        width: 276,
        minHeight: "100%",
        boxSizing: "border-box",
        flexShrink: 0,

        background: "linear-gradient(180deg, #f1fdfb 0%, #e0f2f1 100%)",
        px: 2,
        py: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
      role="presentation"
    >
      {/* Header */}
      <Box>
        <Stack alignItems="center" spacing={1}>
          <Avatar
            sx={{
              bgcolor: "#00838f",
              width: 56,
              height: 56,
              boxShadow: 3,
            }}
          >
            <FingerprintIcon />
          </Avatar>
          <Typography
            variant="h6"
            sx={{ color: "#00695c", fontWeight: 800, letterSpacing: 0.4 }}
          >
            Bee Attendance
          </Typography>
          <Chip
            label="v1.0"
            size="small"
            sx={{ bgcolor: "#e0f7fa", color: "#006064", fontWeight: 700 }}
          />
        </Stack>

        <Divider sx={{ my: 2.5 ,width:"100%"}} />

        {/* Navigation */}
        <List sx={{ display: "flex", flexDirection: "column", gap: 0.5}}>
          {/* Finger Print */}
          <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/home/"
              sx={navButtonSx}
              onClick={handleNavClick}
            >
              <ListItemIcon>
                <FingerprintIcon sx={{ color: "#00796b" }} />
              </ListItemIcon>
              <ListItemText
                primary="Finger Print"
                secondary="Capture attendance"
                primaryTypographyProps={{
                  sx: { fontWeight: 600, color: "#004d40" },
                }}
                secondaryTypographyProps={{ sx: { color: "text.secondary" } }}
              />
            </ListItemButton>
          </ListItem>

          {/* Attendance section header */}
          <ListItem sx={{ py: 1 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <EventIcon sx={{ color: "#00796b" }} />
            </ListItemIcon>
            <ListItemText
              primary="Attendance"
              
              primaryTypographyProps={{
                sx: { fontWeight: 700, color: "#004d40", fontSize: 14 },
              }}
              secondaryTypographyProps={{ sx: { color: "text.secondary" } }}
            />
          </ListItem>


          {/* Two buttons instead of dropdown */}
          
          <ListItem disablePadding sx={{ mb: 0.5 }}>
            <Box sx={{ width: "100%" }}>
              <Stack direction="column" spacing={1}>
                <Button
                  component={NavLink}
                  to="/home/calendar/"
                  onClick={handleNavClick}
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={attBtnPrimary}
                >
                  My Attendance
                </Button>

                <Button
                  component={NavLink}
                  to="/home/calendar/EmployeesActions"
                  onClick={handleNavClick}
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={attBtnPrimary}
                >
                  All Employees Status 
                </Button>

          {showAttendanceDropdown && 
          <>
            {/* {console.log("DEBUG: rendering attendance dropdown buttons NOW")} */}
                {/* <Button
                  component={NavLink}
                  to="/home/calendar/all"
                  onClick={handleNavClick}
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={attBtnSecondary}
                >
                  All Attendances
                </Button> */}

                {/* <Button
                  component={NavLink}
                  to="/home/calendar/new"
                  onClick={handleNavClick}
                  variant="outlined"
                  size="small"
                  fullWidth
                  sx={attBtnSecondary}
                >
                  All Attendances 
                </Button> */}
                </>
                  }
                
              </Stack>
            </Box>
          </ListItem>

           {/* Attendance section header */}
          <ListItem sx={{ py: 1 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <EventIcon sx={{ color: "#00796b" }} />
            </ListItemIcon>
            <ListItemText
              primary="Attendance Manually"
              
              primaryTypographyProps={{
                sx: { fontWeight: 700, color: "#004d40", fontSize: 14 },
              }}
              secondaryTypographyProps={{ sx: { color: "text.secondary" } }}
            />
          </ListItem>


          {/* Two buttons instead of dropdown */}
          
          <ListItem disablePadding sx={{ mb: 0.5 }}>
            <Box sx={{ width: "100%"}}>
              <Stack direction="column" spacing={1}>
                <Button
                  component={NavLink}
                  to="/home/calendar/ManualAttendance"
                  onClick={handleNavClick}
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={attBtnPrimary}
                >
                  Attendance Manually
                </Button>
              </Stack>
            </Box>
          </ListItem>

          {/* Attendance section header */}
          <ListItem sx={{ py: 1 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <EventIcon sx={{ color: "#00796b" }} />
            </ListItemIcon>
            <ListItemText
              primary="Visits"
              
              primaryTypographyProps={{
                sx: { fontWeight: 700, color: "#004d40", fontSize: 14 },
              }}
              secondaryTypographyProps={{ sx: { color: "text.secondary" } }}
            />
          </ListItem>

          {/* Two buttons instead of dropdown */}
          
          <ListItem disablePadding sx={{ mb: 0.5 }}>
            <Box sx={{ width: "100%" }}>
              <Stack direction="column" spacing={1}>

                <Button
                  component={NavLink}
                  to="/home/calendar/visits"
                  onClick={handleNavClick}
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={attBtnPrimary}
                >
                  Visits
                </Button>

                {canApproveVisits && (
                  <Button
                    component={NavLink}
                    to="/home/calendar/approve-visits"
                    onClick={handleNavClick}
                    variant="contained"
                    size="small"
                    fullWidth
                    sx={attBtnPrimary}
                  >
                    Approve Visit Request
                  </Button>
                )}
              </Stack>
            </Box>
          </ListItem>


          {/* Leave section header */}
          <ListItem sx={{ py: 1 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <BeachAccessIcon sx={{ color: "#00796b" }} />
            </ListItemIcon>
            <ListItemText
              primary="Leave"
              
              primaryTypographyProps={{
                sx: { fontWeight: 700, color: "#004d40", fontSize: 14 },
              }}
              secondaryTypographyProps={{ sx: { color: "text.secondary" } }}
            />
          </ListItem>

          <ListItem disablePadding sx={{ mb: 0.5 }}>
            <Box sx={{ width: "100%" }}>
              <Stack direction="column" spacing={1}>
                <Button
                  component={NavLink}
                  to="/home/calendar/leaveRequest"
                  onClick={handleNavClick}
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={attBtnPrimary}
                >
                  All Leave Requests
                </Button>

                {canApproveLeaves && (
                  <Button
                    component={NavLink}
                    to="/home/calendar/approve"
                    onClick={handleNavClick}
                    variant="contained"
                    size="small"
                    fullWidth
                    sx={attBtnPrimary}
                  >
                    Approve Leave Request
                  </Button>
                )}

                </Stack>
                </Box>
                </ListItem>

                  {showAttendanceDropdown && 
                    <>
                    {/* <Button
                      component={NavLink}
                      to="/home/calendar/approve"
                      onClick={handleNavClick}
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={attBtnSecondary}
                    >
                      Approve Leave Request
                    </Button> */}
                    </>
                      }


          <Divider sx={{ my: 1.5, mx: 1 }} />

          {/* History */}
          {/* <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/home/history?type=posted"
              sx={navButtonSx}
              onClick={handleNavClick}
            >
              <ListItemIcon>
                <DoneIcon sx={{ color: "#00838f" }} />
              </ListItemIcon>
              <ListItemText
                primary="Posted History"
                secondary="Synced entries"
                primaryTypographyProps={{
                  sx: { fontWeight: 600, color: "#004d40" },
                }}
                secondaryTypographyProps={{ sx: { color: "text.secondary" } }}
              />
            </ListItemButton>
          </ListItem> */}
      
          {/* pending section header */}
          {/* <ListItem sx={{ py: 1 }}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <PendingActionsIcon sx={{ color: "#00796b" }} />
            </ListItemIcon>
          </ListItem> */}


          <ListItem disablePadding sx={{ mb: 0.5 }}>
            <Box sx={{ width: "100%" }}>
              <Stack direction="column" spacing={1}>
                <Button
                  component={NavLink}
                  to="/home/history?type=pending"
                  onClick={handleNavClick}
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={attBtnPrimary}
                >
                  Pending History
                </Button>
                </Stack>
                </Box>
                </ListItem>

          {/* <ListItem disablePadding>
            <ListItemButton
              component={NavLink}
              to="/home/history?type=pending"
              sx={navButtonSx}
              onClick={handleNavClick}
            >
              <ListItemIcon>
                <ScheduleIcon sx={{ color: "#00838f" }} />
              </ListItemIcon>
              <ListItemText
                primary="Pending History"
                secondary="Not yet synced"
                primaryTypographyProps={{
                  sx: { fontWeight: 600, color: "#004d40" },
                }}
                secondaryTypographyProps={{ sx: { color: "text.secondary" } }}
              />
            </ListItemButton>
          </ListItem> */}

        </List>
      </Box>

      {/* Footer */}
      <Box>
        <Divider sx={{ my: 2 ,width:"100%"}} />
        <ListItem disablePadding>
          <ListItemButton
            onClick={() => {
              onLogout();
              onClose();
            }}
            sx={logoutButtonSx}
          >
            <ListItemIcon>
              <LogoutIcon sx={{ color: "#d32f2f" }} />
            </ListItemIcon>
            <ListItemText
              primary="Logout"
              primaryTypographyProps={{
                sx: { color: "#b71c1c", fontWeight: 600 },
              }}
            />
          </ListItemButton>
        </ListItem>
      </Box>
    </Box>
  );
}

/** Styles */
const navButtonSx = {
  borderRadius: 2,
  px: 2,
  py: 1.25,
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "#b2ebf2",
    transform: "translateX(4px)",
  },
  "&.active": {
    backgroundColor: "rgba(0, 121, 107, 0.15)",
    outline: "1px solid rgba(0, 121, 107, 0.25)",
  },
};

const logoutButtonSx = {
  borderRadius: 2,
  px: 2,
  py: 1.25,
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: "#ffcdd2",
    transform: "translateX(4px)",
  },
};

/** Attendance buttons styles */
const attBtnPrimary = {
  textTransform: "none",
  fontWeight: 700,
  bgcolor: "#009688",
  "&:hover": { bgcolor: "#00796b" },
};

const attBtnSecondary = {
  textTransform: "none",
  fontWeight: 700,
  borderColor: "rgba(0, 150, 136, 0.5)",
  color: "#00695c",
  "&:hover": { borderColor: "#00796b", backgroundColor: "rgba(0, 121, 107, 0.08)" },
};
